import { useState, useCallback } from 'react';
import { IAgenciesAttributes, IAgenciesDivisionAttributes } from 'shared/interfaces/IRepresentatives';
import { HandleSetFieldValueValueProps } from '../model/AddRepresentativeSchema';

const anyValue = {
  id: 'Any',
  name: 'Any',
};

export const useRepresentativesAgencyInput = (handleSetFieldValue: HandleSetFieldValueValueProps) => {
  // The list of divisions available
  const [agencyDivision, setAgencyDivision] = useState<IAgenciesDivisionAttributes[]>([]);

  const handleAgencyOnChangeCB = useCallback((value: IAgenciesAttributes | null) => {
    if (!value) {
      /* 
        If value is null, it means the client clear the Agency type field form,
        inside the handleSetFieldValue, this will clear the division_ids, agency_id and access_code
        this function can be seen in useAddRepresentativesFormik
      */
      handleSetFieldValue('agency_id', '');
      return;
    }
    const { divisions = [], required_access_code = false } = value;
    // first parameter is the field name, second the id, and the third is the optional field if it requires access_code or division
    handleSetFieldValue('agency_id', value?.id, {
      required_access_code: required_access_code || false,
      division_required: divisions?.length > 0,
    });
    // Set the division if theres division and the anyValue
    setAgencyDivision([anyValue, ...divisions]);
  }, []);

  return {
    agencyDivision,
    handleAgencyOnChangeCB,
  };
};
